module.exports = __webpack_public_path__ + "img/register-v2.c10c9857.svg";